import React from "react";
import { Link } from "react-router-dom";
import l from "components/util/l";
import { IS_LITE } from "settings";
import Flows from "components/presentation/start/Flows";
import Folders from "components/presentation/start/Folders";
import CollaborationStats from "components/presentation/start/stats/CollaborationStats"
import "styles/css/presentation/Start.css";


const StartView = ({
  user,
  currentFlow,
  selectedFolder,
  isDeveloper,
  setSelectedFolder,
  closeStart,
  onClickCreateFlow,
  onChangeFlow
}) => (
  <div id="start" className="card card-body">

    <div className="w-100">
      <div className='close-wrapper float-right'>
        <button
          type="button"
          className="btn btn-sm px-0 py-0 mt-n4"
          onClick={closeStart}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div className="d-flex w-100 mt-n3 flex-column flex-md-row">
      <div className="nav-container pr-0 pr-md-5">

        {!IS_LITE &&
          <button
            className={"btn btn-accent w-100 mt-2 mb-1"}
            onClick={onClickCreateFlow}>
            <i class="fas fa-agent mr-2"></i>{l("Crear solución%SB033")}
          </button>}

        {IS_LITE && isDeveloper &&
          <Link to="/sync_flow" className="btn btn-accent w-100 mt-2 mb-1">
            <i class="fas fa-sync mr-2"></i>{l("Sincronizar nueva solución%EN040")}
          </Link>}

        <Folders
          user={user}
          selectedFolder={selectedFolder}
          isDeveloper={isDeveloper}
          setSelectedFolder={setSelectedFolder}
        />
      </div>
      <div className="start-container w-100 flex-fill pr-2">
        <Flows
          user={user}
          folder={selectedFolder}
          currentFlow={currentFlow}
          onChangeFlow={onChangeFlow}
          selectedFolder={selectedFolder}
        />

        <div style={{ marginTop: "1.5rem", marginBottom: "3rem" }}>
          <CollaborationStats user={user} />
        </div>
      </div>
    </div>
  </div>
);

export default StartView;